import { useCallback, useState } from 'react'
import {
  INITIAL_TICKET_DRAFT,
  updateDraft,
  validateDraft,
} from '../utils/ticketDraft'

/**
 * Estado del borrador de un ticket nuevo, compartido por los tres modos de
 * creación. La prioridad se deriva sola de Impacto × Urgencia.
 *
 * @param {Object} [initial=INITIAL_TICKET_DRAFT]
 * @returns {{
 *   draft: Object,
 *   errors: Record<string, string>,
 *   setField: (key: string, value: *) => void,
 *   patch: (changes: Object) => void,
 *   validate: (fields?: string[]) => boolean,
 *   reset: () => void
 * }}
 */
export default function useTicketDraft(initial = INITIAL_TICKET_DRAFT) {
  const [draft, setDraft] = useState(initial)
  const [errors, setErrors] = useState({})

  const patch = useCallback((changes) => {
    setDraft((prev) => updateDraft(prev, changes))
    // Al editar un campo se limpia su error.
    setErrors((prev) => {
      const next = { ...prev }
      Object.keys(changes).forEach((key) => delete next[key])
      return next
    })
  }, [])

  const setField = useCallback((key, value) => patch({ [key]: value }), [patch])

  /** Valida (todo o sólo `fields`) y deja visibles los errores. */
  const validate = useCallback(
    (fields) => {
      const found = validateDraft(draft, fields)
      setErrors(found)
      return Object.keys(found).length === 0
    },
    [draft]
  )

  const reset = useCallback(() => {
    setDraft(initial)
    setErrors({})
  }, [initial])

  return { draft, errors, setField, patch, validate, reset }
}
